import React, { useState } from 'react';
import i18n from '../i18n';
import './LanguageSelector.scss';

export default function LanguageSelector(props) {
  const [isLanguageOptionsExpanded, setIsLanguageOptionsExpanded] = useState(false);
  const languageSelected = localStorage.getItem('lang');

  const toggleDropdown = () => setIsLanguageOptionsExpanded(!isLanguageOptionsExpanded);
  const changeLang = (langId) => {
    const curLang = localStorage.getItem('lang');
    if (curLang !== langId) {
      i18n.activate(langId);
      localStorage.setItem('lang', langId);

      // We need to force a rerender of the app, and that's not possible in v2 when
      // using React functional components. So we reload:
      window.location.reload();
    }

    toggleDropdown();
  }

  const languages = {
    "es": "Español",
    "en": "English",
    "pt": "Português",
    "de": "Deutsch"
  }

  return <div id="language-selector" className={`noselect ${props.animationClass}`}>
    <div className="language-selected"
      onClick={toggleDropdown}>
      <div className={`flag ${languageSelected}`}></div><div>{languages[languageSelected]}</div>
      <i className={`fas fa-chevron-${isLanguageOptionsExpanded ? 'down' : 'up'}`}></i>
    </div>
    <div className={`language-options-list ${isLanguageOptionsExpanded ? 'expanded' : ''}`}>
      {Object.keys(languages).map((langId) => {
        return <div key={`lang-${langId}`} className="language-option" onClick={() => changeLang(langId)}>
          <div className={`flag ${langId}`}></div>
          <div>{languages[langId]}</div>
        </div>
      })}
    </div>
  </div>;
}
